<template>
    <div align="center" class="sidebar">
        <div class="sys-name">田田鲜花店</div>
        <div style="margin-top: 40px"><img src="../assets/image/avatar.png"/></div>
        <div class="user-name">{{user.name}}</div>
        <div class="user-info">
            {{user.role|role}} | <span style="cursor: pointer" @click="logout">退出系统</span>
        </div>
        <div class="content">
            <div v-for="item in menus" :class="{'menu-item':true,'cur-item':aciveInd==item.index}"  @click="go(item)" style="padding-left: 65px;">
                <i :class="`fa ${item.icon}`"></i>{{item.name}}
            </div>
        </div>
    </div>
</template>

<script type="application/ecmascript">
    export default {
        name: 'sidebar',//侧边栏
        data () {
            return {
                power:JSON.parse(localStorage.user).role,
                menus: [
                    {name:'商品管理',path:'/goods',icon:'fa-shopping-cart',index:'1'},
                    {name:'首页管理',path:'/home',icon:'fa-home',index:'2'},
                    {name:'分类标签',path:'/label',icon:'fa-tags',index:'3'},
                    {name:'订单管理',path:'/order',icon:'fa-list',index:'4'},
                    {name:'送货管理',path:'/delivery',icon:'fa-truck ',index:'5'},
                    {name:'用户管理',path:'/customer',icon:'fa-user ',index:'6'},
                    {name:'公众号菜单',path:'/menu',icon:'fa-wechat',index:'7'},
                    {name:'统计报表',path:'/report',icon:'fa-flag',index:'8'},
                    {name:'数据字典',path:'/dict',icon:'fa-table',index:'100'},
                ],
                aciveInd:'',
                user:JSON.parse(localStorage.user),
                levels:[],
            }
        },
        mounted() {
            this.matchActive();
        },
        watch: {
            "$route": "matchActive",
        },
        methods:{
            matchActive(){
                let path = sessionStorage.toPath;
                for (let i = 0; i < this.menus.length; i++) {
                    let obj = this.menus[i];
                    if(obj.path == path){
                        return this.aciveInd = obj.index;
                    }
                }
            },
            go(item){
                if(item.index == this.aciveInd) return;
                this.aciveInd = item.index;
                this.$router.push({path:item.path})
            },
            logout(){
                localStorage.clear();
                this.$router.push({path:'/login'});
            },
        }
    }
</script>

<style scoped>
    .sidebar{
        width: 230px;height: 100vh; padding: 0 10px;position: fixed;color:#F8F9FA;
        background-image :url('../assets/image/sidebar-bg.png');background-size:100% 100%;
    }
    .sys-name{
        margin-top: 20px;font-size:24px;font-weight:400;
    }
    .user-name{
        font-size:15px;font-weight:bold;margin: 20px 0 15px 0;
    }
    .user-info{
        font-weight:400;margin-bottom: 20px;
    }
    .menu-item{
       padding: 20px;border-radius: 5px;cursor: pointer;
    }
    .menu-item .fa{
        margin-right: 10px;
    }
    .cur-item{
        background:#43BDCF;cursor:default;
    }
    .copy-right{
        text-align:center;position:absolute; bottom:20px; color:#fff;width: calc(100% - 20px);text-align: center;
    }
    .content{
        height: calc(100vh - 260px);
        overflow-y: auto;
        text-align: left;
    }
</style>